import _ from 'lodash'

import {normalize} from '../../utils/normalize.js'

// Only the values, so a free search does not match on the names of fields
function valuesToString(value) {
    if (value === null || value === undefined) return ''
    if (Array.isArray(value)) return value.map(valuesToString).join(' ')
    if (typeof value === 'object') return Object.values(value).map(valuesToString).join(' ')
    return String(value)
}

// Whether an object matches all SearchBar queries (see SearchBar/types.ts): a query with a key compares that value, one
// without matches anywhere in the object. Kept free of app imports so it can be unit tested.
export function filter(object, queries) {
    return _.every(queries, (query) => {
        const values = query.text.split('||')

        if (query.key) {
            if (query.operator === '=') {
                return _.some(values, (value) => {
                    value = value.trim().toLowerCase()
                    if (value === '') {
                        return normalize(traverse(object, query.key).toString().toLowerCase()) == normalize(value)
                    } else {
                        return normalize(traverse(object, query.key).toString().toLowerCase()).indexOf(normalize(value)) > -1
                    }
                })
            } else if (query.operator === '==') {
                return _.some(values, (value) => {
                    value = value.trim().toLowerCase()
                    return normalize(traverse(object, query.key).toString().toLowerCase()) == normalize(value)
                })
            } else if (query.operator === '!=') {
                return _.every(values, (value) => {
                    value = value.trim().toLowerCase()
                    if (value === '') {
                        return normalize(traverse(object, query.key).toString().toLowerCase()) != normalize(value)
                    } else {
                        return normalize(traverse(object, query.key).toString().toLowerCase()).indexOf(normalize(value)) == -1
                    }
                })
            } else if (query.operator === '<') {
                return _.every(values, (value) => {
                    value = value.trim()
                    return parseFloat(traverse(object, query.key)?.toString().replace(/,/g, '.')) < parseFloat(value.replace(/,/g, '.'))
                })
            } else if (query.operator === '>') {
                return _.every(values, (value) => {
                    value = value.trim()
                    return parseFloat(traverse(object, query.key)?.toString().replace(/,/g, '.')) > parseFloat(value.replace(/,/g, '.'))
                })
            }
        } else {
            if (query.operator === '=') {
                return _.some(values, (value) => {
                    value = value.trim().toLowerCase()
                    return normalize(valuesToString(object).toLowerCase()).indexOf(normalize(value)) > -1
                })
            } else if (query.operator === '!=') {
                return _.every(values, (value) => {
                    value = value.trim().toLowerCase()
                    return normalize(valuesToString(object).toLowerCase()).indexOf(normalize(value)) === -1
                })
            }
        }
    })
}

/**
 * Rows of a Table filtered on what its columns show: a column's text(row), or else its key's value when that is a
 * plain value (a column that only renders, e.g. an icon, has no text to search). Search text without a column
 * matches any of these texts, never ids or other data the table doesn't show.
 */
export function byColumns(rows, queries, columns) {
    if (!queries.length) {
        return rows
    }

    const searchable = columns.filter((column) => column.key)

    return rows.filter((row) => {
        const texts = {}

        for (const column of searchable) {
            const value = column.text ? column.text(row) : traverse(row, column.key)
            // Nested like the row, filter reads a dotted key (e.g. 'address.city') with traverse
            _.set(texts, column.key, typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' ? value : '')
        }

        return filter(texts, queries)
    })
}

/**
* Traverse an object the find the value for the given multilevel key
* @param {object} obj
* @param {string} key multilevel key seperated by dots
* @return {string}
*/
export function traverse(obj, key) {
    if (key) {
        return key.split('.').reduce((cur, key) => {
            return cur?.[key] ?? ''
        }, obj)
    } else {
        return ''
    }
}
